import { useQuery } from '@tanstack/react-query';
import api, { type ArcheDisplayMeta } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Batch-resolve display metadata (name + icon) for a set of arche ids in one
 * request, so an admin list of submissions tagged with arches doesn't fire N
 * lookups. Null/duplicate ids are filtered out. Returns a Map keyed by archId.
 */
export function useArcheDisplayMap(archeIds: (string | null | undefined)[]): {
  metaById: Map<string, ArcheDisplayMeta>;
  isLoading: boolean;
} {
  const ids = [...new Set(archeIds.filter((x): x is string => Boolean(x)))];

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.customerSupport.archeMeta(ids),
    queryFn: () => api.getArcheDisplayMeta(ids),
    enabled: ids.length > 0,
    staleTime: 5 * 60 * 1000,
  });

  const metaById = new Map<string, ArcheDisplayMeta>(
    (data?.arches ?? []).map((a) => [a.archId, a]),
  );

  return { metaById, isLoading };
}
